import React from 'react';
import PropTypes from 'prop-types';
import { InputWrapperContainer } from '../../input/inputWrapper.container';
import { trans } from '../../../modules/translation/translate';
import SeedStoreController from '../../../../../common/components/storeControllers/SeedStoreController';
import { Loader } from '../../loader/loader';
import { Button } from '../../../../../ui/components/button';

class ClientSeedInput extends React.PureComponent {
	static propTypes = {
		value: PropTypes.any,
		onClick: PropTypes.func,
	};

	render() {
		return (
			<>
				<SeedStoreController />
				<InputWrapperContainer
					value={this.props.value}
					name={'client-seed'}
					label={trans({ label: 'Current client seed' })}
					isDisabled={true}
					inputButtons={[
						<Button
							key={1}
							name="provably-fair-generate-new-client-seed"
							onClick={this.props.onClick}
							label={trans({ label: 'Change' })}
						>
							<Loader loader="reloadClientSeed" />
						</Button>,
					]}
				/>
			</>
		);
	}
}

export { ClientSeedInput };
